import * as React from 'react';
export const YUSvg = React.forwardRef(function YUSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M16 4v2H0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M0 12v-2h16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'm10.755 7-1.75.004a.243.243 0 0 1-.231-.168l-.542-.665a.243.243 0 0 0-.464 0l-.54.664a.243.243 0 0 1-.231.168H5.246a.243.243 0 0 0-.143.441l1.415 1.03a.243.243 0 0 1 .089.272l-.54 2.665a.243.243 0 0 0 .375.272l1.415-.95a.243.243 0 0 1 .287 0l1.416.95a.243.243 0 0 0 .376-.272l-.542-2.665a.243.243 0 0 1 .088-.273l1.416-1.029A.246.246 0 0 0 10.755 7Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'm10.755 7-1.75.004a.243.243 0 0 1-.231-.168L8.232 5.17a.243.243 0 0 0-.464 0l-.54 1.664a.243.243 0 0 1-.231.168H5.246a.243.243 0 0 0-.143.441l1.415 1.03a.243.243 0 0 1 .089.272l-.54 1.665a.243.243 0 0 0 .375.272l1.415-.95a.243.243 0 0 1 .287 0l1.416.95a.243.243 0 0 0 .376-.272l-.542-1.665a.243.243 0 0 1 .088-.273l1.416-1.029A.246.246 0 0 0 10.755 7Z',
      }),
    ),
  );
});
YUSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var YU = {
  category: 'flag',
  colorable: false,
  name: 'YU',
  svg: YUSvg,
};
